// Resources
import { Analytics } from "@segment/analytics-node";

// Segment
export const analytics = new Analytics({
    writeKey: "TOeAZuXJGxHRhHptb4dO8l3jozopvQH2"
});
